export const TabJSXConverter = {
  tab: ({
    node
  }) => {
    // Tab
    return node.text;
  }
};
//# sourceMappingURL=tab.js.map